import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveInvestmentPurposeAndNatureMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientInvestmentPurposeAndNatureParam } from 'api/types/params';

import {
  parseLegalClient,
  parseLegalClientInvestmentPurposeAndNatureParam,
} from './helpers';

export const useLegalClientSaveInvestmentPurposeAndNature = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveInvestmentPurposeAndNatureMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveInvestmentPurposeAndNature
      ? parseLegalClient(data.legalClientSaveInvestmentPurposeAndNature)
      : undefined,
    loading,
    error,
    saveInvestmentPurposeAndNature: useCallback(
      async (
        id: string,
        params: LegalClientInvestmentPurposeAndNatureParam
      ) => {
        const input = parseLegalClientInvestmentPurposeAndNatureParam(params);
        const res = await handle({
          variables: {
            id,
            input,
          },
        });
        return res.data?.legalClientSaveInvestmentPurposeAndNature
          ? parseLegalClient(res.data.legalClientSaveInvestmentPurposeAndNature)
          : undefined;
      },
      [handle]
    ),
  };
};
